import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class BatchServices {
  getBatches = async (tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch,
    endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock) => {
    let url = `${Constants.BATCH}?`;
    if (tenantProductId) url += `tenant_product_id=${tenantProductId}&`;
    if (batchNumber) url += `batch_number=${batchNumber}&`;
    if (batchId) url += `batch_id=${batchId}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (availableQuantity) url += `map_available_qty=${!!availableQuantity}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (productSkuId) url += `&product_sku_id=${productSkuId}&`;
    if (departmentId) url += `&department_id=${departmentId}&`;
    if (selectedTenant) url += `tenant_ids=${selectedTenant}&`;
    if (startDateEpoch) url += `created_date_from=${startDateEpoch}&`;
    if (endDateEpoch) url += `created_date_to=${endDateEpoch}&`;
    if (expiryStartDateEpoch) url += `expiry_date_from_date=${expiryStartDateEpoch}&`;
    if (expiryEndDateEpoch) url += `expiry_date_to_date=${expiryEndDateEpoch}&`;
    if (inventoryLocation) url += `inventory_location_id=${inventoryLocation}&`;
    if (category) url += `product_category_ids=${category}&`;
    if (expiryStatus) url += `expiry_status=${expiryStatus}&`;
    if (availableStock) url += `&quantity_class=${availableStock}`;
    const batches = await Helpers.get({ url });
    return batches;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  createBatch = async (payload) => {
    const createdBatch = await Helpers.post({
      url: Constants.BATCH,
      data: payload,
    });
    return createdBatch;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  getReservations = async (payload) => {
    const reservations = await Helpers.post({
      url: `${Constants.BASE_URL}/reserve/list`,
      data: payload,
    });
    return reservations;
  }
}
export default new BatchServices();
